import React from "react";
import { FormikErrors, FormikValues, FormikTouched, ErrorMessage } from "formik";
import { Label, Input as InputField } from "reactstrap";
import { AlertCircle } from "react-feather";

type IType =
	| "text"
	| "email"
	| "number"
	| "password"
	| "checkbox"
	| "select"
	| "textarea"
	| "hidden"
	| "date";
interface IInputFieldProps {
	label?: string;
	name: string;
	placeholder?: string;
	value: any;
	errors: FormikErrors<FormikValues>;
	touched: FormikTouched<FormikValues>;
	handleOnBlur?(e: React.FocusEvent<any>): void;
	handleChange?(e: React.ChangeEvent<HTMLInputElement>): void;
	disabled?: boolean;
	type?: IType;
	style?: React.CSSProperties;
	rows?: number;
	children?: any;
}

const Input: React.FC<IInputFieldProps> = (props) => {
	const {
		label,
		name,
		placeholder,
		value,
		errors,
		touched,
		handleChange,
		disabled,
		type,
		handleOnBlur,
		style
	} = props;

	const hasError = touched[name] && errors[name];
	const errorMessage = hasError ? String(errors[name]) : null;

	return (
		<>
			{label && (
				<Label for={name} className="color-battleship-grey">
					{label}
				</Label>
			)}
			<InputField
				className={`w-100 px-3 py-2 font-16 ${hasError ? "is-invalid" : ""}`}
				style={{
					borderRadius: 6,
					borderColor: hasError ? "#dc3545" : undefined,
					...style
				}}
				value={value}
				onChange={handleChange}
				disabled={disabled}
				type={type}
				name={name}
				onBlur={handleOnBlur}
				id={name}
				placeholder={placeholder}
				aria-invalid={hasError ? "true" : "false"}
				aria-describedby={hasError ? `${name}-error` : undefined}
			>
				{props.children}
			</InputField>

			<ErrorMessage
				name={name}
				render={(error) => (
					<div
						id={`${name}-error`}
						role="alert"
						aria-live="polite"
						style={{
							display: "flex",
							alignItems: "flex-start",
							marginTop: "0.25rem",
							marginBottom: "0.5rem",
							color: "#dc3545",
							fontSize: "0.875rem",
							lineHeight: "1.25rem"
						}}
					>
						<AlertCircle
							size={14}
							style={{
								marginRight: "0.375rem",
								marginTop: "0.125rem",
								flexShrink: 0
							}}
						/>
						<span>{error}</span>
					</div>
				)}
			/>
		</>
	);
};

export default Input;
